<template>
  <div>
    <group class="contact-list">
      <x-input title="联系人姓名" v-model="contactName" placeholder="联系人姓名"></x-input>
      <x-input title="联系人电话" v-model="contactNumber" placeholder="联系人电话"></x-input>
    </group>
    <div class="btn-bottom">
      <div class="btn-fix">
        <x-button class="btn" @click.native="handleConfirm">{{ isEdit ? '确认修改' : '确认添加' }}</x-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Group,
  XInput,
  XButton
} from '@lx-frontend/cvux'
import util from '../../../common/util'

export default {
  components: {
    Group,
    XInput,
    XButton
  },
  props: {
    editContact: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      contactName: this.editContact.contact_name || '',
      contactNumber: this.editContact.contact_number || '',
      isEdit: Boolean(this.editContact.id)
    }
  },
  methods: {
    async handleConfirm() {
      const contactName = this.contactName
      const contactNumber = this.contactNumber
      if (contactName.length < 2 || contactName.length > 8 || !util.regexpMap.regexp_name_cn.test(contactName)) {
        this.showToast('联系人姓名必须为2~8个长度的中文')
        return false
      }
      if (!util.regexpMap.regexp_mobile.test(contactNumber)) {
        this.showToast('请输入正确的手机号码')
        return false
      }

      const params = {
        contact_name: contactName,
        contact_number: contactNumber
      }
      const res = this.isEdit ? await this.$rest.auction.editContact(params, this.editContact.id) : await this.$rest.auction.addContact(params)

      if (res.code === 0) {
        this.$emit('onConfirm', this.isEdit ? this.editContact.id : res.data.contacts.id)
      } else {
        this.showToast(res.message)
      }
    }
  },
  watch: {
    editContact(val) {
      this.contactName = val.contact_name || ''
      this.contactNumber = val.contact_number || ''
      this.isEdit = Boolean(this.editContact.id)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../../stylesheets/base/fn.less';
.btn {
  background-color: #3b5999;
  border-radius: 0;
  color: #fff;
}
</style>
